module.exports = __webpack_public_path__ + "static/assets/6114bf1f4779d049ae3a1c8dff1f6847.png";